module.exports = __webpack_public_path__ + "static/media/framer.4cba0a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/framer.jpg
// module id = 362
// module chunks = 0